/* Publish by EComposer at 2026-09-30 08:43:05*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-tpay4p7h1c8"]=  window.__ectimmers["ecom-tpay4p7h1c8"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-tpay4p7h1c8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tpay4p7h1c8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h6w4mb1deim').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h6w4mb1deim', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pvc8mxxthi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pvc8mxxthi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-poh7z9u52m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-poh7z9u52m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xut5z6oqhb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xut5z6oqhb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hu6w2tyi7is').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hu6w2tyi7is', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pwxiaxpz7t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pwxiaxpz7t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3tlo3czpf84').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3tlo3czpf84', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rq3gjqtg0x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rq3gjqtg0x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kmt34e4w56').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kmt34e4w56', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rktagclts4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rktagclts4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mk4cin0qhgj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mk4cin0qhgj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h7nolrmgyb7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h7nolrmgyb7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-efpbfyxugf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-efpbfyxugf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9yb5j7b8x2f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9yb5j7b8x2f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uajlouds9j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uajlouds9j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kuoovxzvs48').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kuoovxzvs48', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-33i0wtktykr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-33i0wtktykr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k5ajbphflje').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k5ajbphflje', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zanpeiux76').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zanpeiux76', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xbyye3ggnxe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xbyye3ggnxe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jsu5iw9tbz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jsu5iw9tbz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5c4kpl88t07').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5c4kpl88t07', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1xj3mvj89nr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1xj3mvj89nr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o5peq1to4v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o5peq1to4v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-df25xbgs2j9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-df25xbgs2j9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sp2j1vdfzqe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sp2j1vdfzqe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x68j11e5vfd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x68j11e5vfd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8k1bb1nmsy8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8k1bb1nmsy8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o1mezr7lvd8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o1mezr7lvd8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5z8782j5f3n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5z8782j5f3n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zoopalwyd2c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zoopalwyd2c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-28sjd836ttl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-28sjd836ttl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0d0rjjy11udd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0d0rjjy11udd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b0cv9md5btg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b0cv9md5btg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0t3v04bkx19g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0t3v04bkx19g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mk9jq24z5rc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mk9jq24z5rc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6talx4dwx6h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6talx4dwx6h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aledwvt640r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aledwvt640r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-98fnxtorcta').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-98fnxtorcta', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hyss8cy1f46').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hyss8cy1f46', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gub77lmzz2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gub77lmzz2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qhzl105a1sf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qhzl105a1sf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bh6k3ylfotv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bh6k3ylfotv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f1r3lg2q05u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f1r3lg2q05u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zmx2rgwyq4r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zmx2rgwyq4r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0pqdfui2fekj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0pqdfui2fekj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uy2xpgg5kyf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uy2xpgg5kyf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ll4bmyrs70s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ll4bmyrs70s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-602pvrwx9ud').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-602pvrwx9ud', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dqsyeiq5eze').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dqsyeiq5eze', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ie6ues88tv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ie6ues88tv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v3o4651qk6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v3o4651qk6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-voty7zwhumf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-voty7zwhumf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-keied2dcclr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-keied2dcclr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4b8vtpdkh25').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4b8vtpdkh25', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uqtsmhxh47').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uqtsmhxh47', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-votuu92kgpe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-votuu92kgpe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p2tbtfiu1h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p2tbtfiu1h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dhpk1r1wug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dhpk1r1wug', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h2aoau3ucz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h2aoau3ucz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gjw2ww6aqjm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gjw2ww6aqjm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2iqkxaholck').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2iqkxaholck', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ipyb7m1dwfq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ipyb7m1dwfq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rnxqa1zgecp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rnxqa1zgecp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kgke4aheltb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kgke4aheltb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4lof51se7tc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4lof51se7tc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ldqfitkgud').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ldqfitkgud', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5tak9c7rz95').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5tak9c7rz95', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8sqsmrbhx6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8sqsmrbhx6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-78oyg0vfrp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-78oyg0vfrp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ptgob5yy1ps').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ptgob5yy1ps', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-axzfgabkjqa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-axzfgabkjqa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-egvcvtuizq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-egvcvtuizq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4x7ufea4nlt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4x7ufea4nlt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k25i23ijvih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k25i23ijvih', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bu33sfswfd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bu33sfswfd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3zh3ns3uam4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3zh3ns3uam4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-74n43utr8sq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-74n43utr8sq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cpip5589k0p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cpip5589k0p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-96fea6peg4t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-96fea6peg4t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ka6jsy33snp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ka6jsy33snp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ra90lgqy4yd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ra90lgqy4yd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b7xdkjv7lir').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b7xdkjv7lir', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mfvlww5rco').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mfvlww5rco', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uuy5ovu7tvp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uuy5ovu7tvp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6gjnt2zcq8o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6gjnt2zcq8o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1d0mrxer8u3i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1d0mrxer8u3i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f20et3yj0po').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f20et3yj0po', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0aeide4il1ei').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0aeide4il1ei', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0adjv9ym049').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0adjv9ym049', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3smfry0dlky').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3smfry0dlky', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lw8z62f9fu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lw8z62f9fu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cilacsnr9s5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cilacsnr9s5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-feyh0bkg9ir').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-feyh0bkg9ir', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nonk6x2gg4r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nonk6x2gg4r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ytojpw2r39').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ytojpw2r39', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lndxgx584xk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lndxgx584xk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3sixm3g0468').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3sixm3g0468', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7zml16ctgph').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7zml16ctgph', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h8v7fjxgcg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h8v7fjxgcg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-940p0646d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-940p0646d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-atj10hf3k4u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-atj10hf3k4u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t9n0qlqvylc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t9n0qlqvylc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r3wwnv6cuwf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r3wwnv6cuwf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-euk75jgpc1a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-euk75jgpc1a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dc8x30ua59').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dc8x30ua59', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-usq9uzz0jn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-usq9uzz0jn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2uwhuewfgw6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2uwhuewfgw6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b8gvivbm1m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b8gvivbm1m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n1bwejp3c99').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n1bwejp3c99', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g52hk71hcu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g52hk71hcu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k2zxq4w92ji').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k2zxq4w92ji', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a5hdicwnsul').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a5hdicwnsul', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-txy7hw5aytm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-txy7hw5aytm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f6s79jjat2l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f6s79jjat2l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9etp21qy26n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9etp21qy26n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ttj4ujw1dr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ttj4ujw1dr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h4apny87k6n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h4apny87k6n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g1vcv6hjv2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g1vcv6hjv2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zs2j6kur2wr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zs2j6kur2wr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uucm8x0t8aa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uucm8x0t8aa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jjkqglxlpfq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jjkqglxlpfq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n4mnncfyfg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n4mnncfyfg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c2hkb46lw6u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c2hkb46lw6u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yd82e08x7bo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yd82e08x7bo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dixpv0wmaag').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dixpv0wmaag', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wlfs1q4tafc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wlfs1q4tafc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c1pff3hp9j5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c1pff3hp9j5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c18veahb88f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c18veahb88f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0pv4wvwp2g6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0pv4wvwp2g6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9u0x3lszdu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9u0x3lszdu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4vx1z5wt7ug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4vx1z5wt7ug', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ujsanussjga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ujsanussjga', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ei20b1wewe6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ei20b1wewe6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eauxgq2pd1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eauxgq2pd1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x1zj4uyguoi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x1zj4uyguoi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ys4koas8ot').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ys4koas8ot', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-79lhq23qskc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-79lhq23qskc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9e3qkjecfui').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9e3qkjecfui', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fvcy6e9jryq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fvcy6e9jryq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bk2v4ndqmk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bk2v4ndqmk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ps8de9wlkn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ps8de9wlkn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6b603bhzvlx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6b603bhzvlx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hi3adrccm6b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hi3adrccm6b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-08q3ewpz70mg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-08q3ewpz70mg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dyo24jnz8ma').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dyo24jnz8ma', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a182qy5y0wu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a182qy5y0wu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ma27qy3s76').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ma27qy3s76', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3jz57c8u9wj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3jz57c8u9wj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yvojiw9n6z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yvojiw9n6z', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v97r6f1b8r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v97r6f1b8r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ja7f07vhbas').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ja7f07vhbas', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-66is872v7vn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-66is872v7vn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-36bgi37fqow').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-36bgi37fqow', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u10dhr9vdfa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u10dhr9vdfa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vwgg4myp36').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vwgg4myp36', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z764x3byowg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z764x3byowg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ug65qomih7j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ug65qomih7j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5rjnnnb5nm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5rjnnnb5nm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ky5yzxdtnac').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ky5yzxdtnac', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-whrdx2kx8t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-whrdx2kx8t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vixdlgm7lq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vixdlgm7lq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jnuifqbnvcf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jnuifqbnvcf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5rh16v0nkgk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5rh16v0nkgk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iosxkq0rfum').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iosxkq0rfum', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3fk1ws9djna').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3fk1ws9djna', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-65djxfjtjr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-65djxfjtjr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ch84rs50bl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ch84rs50bl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qjinv5l2ksh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qjinv5l2ksh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zhlzptlksff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zhlzptlksff', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-obsl6hduy4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-obsl6hduy4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o4z7oyld1e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o4z7oyld1e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dyjvodpvhc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dyjvodpvhc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-moz563q9wx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-moz563q9wx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v3ge8j0068m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v3ge8j0068m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5inqtni6to').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5inqtni6to', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y1fmf6i09g9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y1fmf6i09g9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-msjkhccx3n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-msjkhccx3n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-39tsvoo12xg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-39tsvoo12xg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-11zzpcox4vlh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-11zzpcox4vlh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3hvhn6offy5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3hvhn6offy5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g9gd658xddk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g9gd658xddk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-438la0quky2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-438la0quky2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8vudshqr0lf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8vudshqr0lf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3vm19sskr3f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3vm19sskr3f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-juceyo97nrs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-juceyo97nrs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-csglt9bz19l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-csglt9bz19l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8wtv1ofthr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8wtv1ofthr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zllai9d57fr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zllai9d57fr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5cgbc98sjmc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5cgbc98sjmc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dviuyhhkda9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dviuyhhkda9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-11o3ygexlja').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-11o3ygexlja', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l4my6742w3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l4my6742w3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rbbleign51f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rbbleign51f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ebp4s7xvsu7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ebp4s7xvsu7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-23iqve1fkgj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-23iqve1fkgj', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-w2bgarucer"]=  window.__ectimmers["ecom-w2bgarucer"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-w2bgarucer"]["1ngf4n69d"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-w2bgarucer').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w2bgarucer', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bf77yfww44r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bf77yfww44r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y9wkz0fi8cb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y9wkz0fi8cb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ox743s8iuj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ox743s8iuj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0g7z7r3mszd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0g7z7r3mszd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jypsuve2l9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jypsuve2l9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gpss3v35h6j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gpss3v35h6j', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vn00thoepjr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vn00thoepjr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q4lpqv0716b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q4lpqv0716b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8mwut0ae122').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8mwut0ae122', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-he4y688j69v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-he4y688j69v', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qntywjwqy7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qntywjwqy7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q3v5me6x57h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q3v5me6x57h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5teomijutia').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5teomijutia', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a0u0h0y2m6e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a0u0h0y2m6e', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r7vqdqx2ino').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r7vqdqx2ino', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmxs30srvg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmxs30srvg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p2mcx6hyh88').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p2mcx6hyh88', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ucjjtis9nnk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ucjjtis9nnk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2f99swxbys2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2f99swxbys2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0of55adh3pe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0of55adh3pe', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t0aqxd9qdcc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t0aqxd9qdcc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u4aqiqgedhs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u4aqiqgedhs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5r2m81q9mh4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5r2m81q9mh4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6voqw3ygdy2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6voqw3ygdy2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dx2lq74r5ge').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dx2lq74r5ge', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xxs8qqhrp8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xxs8qqhrp8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3bowepniv27').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3bowepniv27', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-28x9pxpzi1o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-28x9pxpzi1o', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ppn5xj27eo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ppn5xj27eo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ocofexkfy3f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ocofexkfy3f', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h8x0nxg4ue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h8x0nxg4ue', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ki9ln7c4cjf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ki9ln7c4cjf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cyrl70uzh6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cyrl70uzh6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a8vaque414g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a8vaque414g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b825hxtquhb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b825hxtquhb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q8rbwn8r3rb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q8rbwn8r3rb', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fauzhwsoy3q"]=  window.__ectimmers["ecom-fauzhwsoy3q"] || {};
var E,$,A,I,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,n=($=this.settings.disable_auto_close__tablet)!=null?$:!1,o=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(L){return o&&L<768||n&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let U=null;function G(oe){U||(U=oe);const se=Math.min((oe-U)/Z,1),Y=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*Y),se<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function k(L){w(v(L)-100)}function S(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,U=Z.querySelector(":scope > .ecom-accordion__body");!r&&U&&U.classList.add("ecom-effect-accodion");const G=Z.classList.contains("ecom-item-active");U&&!a&&(O&&N===0||G)&&requestAnimationFrame(()=>{U.style.height=U.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),Y=this.parentNode,de=Y.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),te=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=_(se);if(q)J?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let fe=Y.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&te&&te.classList.add("ecom-effect-accodion"),b(te)}window.dispatchEvent(new window.Event("renderScroll"));const X=this,ue=s||se>1024;function K(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(X)&&k(X)}if(ue&&!r){let fe;const Te=function(ze){ze.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},600)}else requestAnimationFrame(()=>{setTimeout(K,100)})}})}S(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>S(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-fauzhwsoy3q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fauzhwsoy3q', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kj7ey3ra1k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kj7ey3ra1k', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-eapmwijwqtq"]=  window.__ectimmers["ecom-eapmwijwqtq"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-eapmwijwqtq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eapmwijwqtq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eqyzizru7c7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eqyzizru7c7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dou40bhv5qe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dou40bhv5qe', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ikg7js59dm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ikg7js59dm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j5thxh2eyvd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j5thxh2eyvd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b7swkssgpg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b7swkssgpg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-62da2q02aat').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-62da2q02aat', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0mrv78de2dl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0mrv78de2dl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cpxit7wv42j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cpxit7wv42j', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mpcbvvncwl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mpcbvvncwl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jzx32imm5g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jzx32imm5g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0fg2aawwabdr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0fg2aawwabdr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6pxgsexmtzp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6pxgsexmtzp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6z3h0wigbc9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6z3h0wigbc9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5b2j0qh42e8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5b2j0qh42e8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9mcjooygqvg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9mcjooygqvg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8nnop07pkh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8nnop07pkh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dc0tw62dvhe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dc0tw62dvhe', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5g1thl15vy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5g1thl15vy', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r9y942u506l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r9y942u506l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-asm2y8zdh6a"]=  window.__ectimmers["ecom-asm2y8zdh6a"] || {};
if(!this.settings||!this.$el)return;const t=this.$el,e=this.isLive,i=this.settings.loop,n=this.settings.autoplay,o=this.settings.lazyload||!1,s=this.settings.player_controls||!1,r=this.settings.pause_on_hover||!1,a=this.settings.click_to_play_pause,l=this.settings.play_on_lightbox||!1,c=1;let d=t.querySelector(".ecom-video_overlay-icon");const m=t.querySelector(".ecom-video-poster");let g;g=d&&d.querySelector(".ecom-video-icon-play");const _=t.querySelector(".ecom-element_video-iframe");o&&setTimeout(function(){b(_)},500);function b($){let A={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(w,A).observe($)}function y($,A){let I={handleMouseenter:j,handleMouseleave:T,handleEnded:L};function j(){$.readyState>=c&&$.pause()}function T(){$.readyState>=c&&$.play()}function L(){v($,I)}if(r){$.addEventListener("mouseenter",j),$.addEventListener("mouseleave",T);let O=t.querySelector(".ecom-video_link-extra");O&&O.href&&(O.addEventListener("mouseenter",j),O.addEventListener("mouseleave",T)),A||$.addEventListener("ended",L)}}function v($,A){if(A){const{handleMouseenter:I,handleMouseleave:j,handleEnded:T}=A;let L=t.querySelector(".ecom-video_link-extra");$.removeEventListener("mouseenter",I),$.removeEventListener("mouseleave",j),$.removeEventListener("ended",T),L&&L.href&&(L.removeEventListener("mouseenter",I),L.removeEventListener("mouseleave",j))}}function w($,A){$.forEach(function(I){if(I.isIntersecting){const j=I.target.querySelector("video source"),T=I.target.querySelector("video"),L=I.target.querySelector("iframe");if(T&&j&&(j.src=j.dataset.source,T.load(),T.addEventListener("loadeddata",function(){n&&T.play()})),L){let O=L.dataset.srcVideo;L.setAttribute("src",O)}A.unobserve(I.target)}})}let k=t.querySelector(".ecom_video"),S=t.querySelector(".ecom_iframe");a&&k.addEventListener("click",()=>{k.readyState>=c&&(k.paused?k.play():k.pause())}),n&&(d&&d.classList.remove("ecom-overlay"),g&&(g.style.display="none"),m&&(m.style.display="none")),k&&!i&&k.addEventListener("ended",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),d&&d.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&k)m&&(m.style.display="none"),k.autoplay=!0,k.play(),d.classList.remove("ecom-overlay"),g.style.display="none";else if(S){let $=S.getAttribute("src");$.includes("autoplay=0")?$=$.replace("autoplay=0","autoplay=1"):$=$+"&autoplay=1",S.setAttribute("src",$),l?setTimeout(()=>{$=$.replace("autoplay=1","autoplay=0"),S.setAttribute("src",$)},100):(m&&(m.style.display="none"),d.classList.remove("ecom-overlay"),g.style.display="none")}}),k&&(e&&!m&&y(k,i),m&&m.addEventListener("click",function(){m.style.display="none",k.play(),e&&y(k,i)}),r||k.addEventListener("pause",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),!s&&d&&k.addEventListener("click",function(){k.pause()})),t.querySelectorAll("[data-ec-tracking-id]").forEach(function($){$.dataset.ecTrackingId&&$.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:$.id,tracking_id:$.dataset.ecTrackingId})},{once:!0})});const z=t.querySelector("[ecom-modal]");if(z&&this.settings.image_overlay&&l&&window.EComModal){const $=z.dataset.width,A=z.dataset.height;var E=this.id;new window.EComModal(z,{cssClass:[E,"ecom-core","ecom-core-simulator"],onOpen:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-modal-box__content");j.classList.add("ecom-element_video-iframe");const T={width:$,height:A};Object.assign(j.style,T)}},onClose:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-element_video-iframe iframe");j&&(j.src="")}}})}

                    });
                    
                        document.querySelectorAll('.ecom-asm2y8zdh6a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-asm2y8zdh6a', settings: {"loop":false,"autoplay":false,"player_controls":true,"source":"youtube","image_overlay":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}